<template>
	<div class="head">
		<div class="headInner">
			<div class="headLeft bannerBtnText">
				<router-link to='/index'>
					<img  src="../assets/images/logo.png" class="logoIcon"/>
				</router-link>
				<div class="headLine"></div>
				<div class="headText">
					<div>{{$t('components.head1.intro1')}}</div>
					<div>{{$t('components.head1.intro2')}}</div>
				</div>
				<div class="blueLine"></div>
				<div class="headTitle">{{titleVal}}</div>
			</div>
			<div class="headRight">
				<img  src="../assets/images/headBg.png"/>
				<router-link to='/'>
					<div class="rightText " v-if="type == 'FORGET'">{{$t('components.head1.right1')}}</div>
				</router-link>

				<div class="rightText noBorder" v-if="type=='REISTER'">{{$t('components.head1.right2')}}<router-link  to='/'><span>{{$t('components.head1.right3')}}</span></router-link></div>
			</div>
				
		</div>
		
	</div>
</template>

<script>
	export default {
	  props: ['titleVal','type']
	}
</script>

<style scoped>
	.head{
		background-color: #1d1d1f;
		width: 100%;
		height: 132px;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 1024px;
	}
	
	.headInner{
		width: 1204px;
		display: flex;
		justify-content: space-between;
	}
	
	.headLeft{
		display: flex;
		align-items: center;
	}
	
	.logoIcon{
		margin-right: 27px;
	}
	
	.headLine{
		width: 1px;
		height: 41px;
		background-color: #838384;
	}
	
	.headText{
		font-size: 14px;
		color:#fff;
		margin-left: 27px;
		margin-right: 29px;
	}
	
	.blueLine{
		width: 4px;
		height: 30px;
		background-color: #0380fe;
	}
	
	.headTitle{
		font-size: 18px;
		margin-left: 16px;
		color: #fff;
	}
	
	.headRight{
		position: relative;
	}
	
	.rightText{
		position: absolute;
		top: 0;
		left: 0;
		width: 236px;
		height: 132px;
		text-align: right;
		line-height: 132px;
		color: #fff;
		font-size: 15px;
		text-decoration: underline;
		cursor: pointer;
	}
	.noBorder{
		text-decoration: none;
	}
	
	.noBorder span{
		text-decoration: underline;
		color: #fff;
	}
</style>